// @flow

import type { Node } from 'react';

import type { Tax } from '@gandi/cart';
import { useTranslator } from '@gandi/translate';
import { PopoverIcon } from '@gandi/ui';

import styles from './TotalTaxRow.scss';

type Props = {
  tax: Tax,
  currency: string,
};

function useTaxLabels({ rate = 0 }: Tax) {
  const { __ } = useTranslator();

  return {
    zipcode: [__('Local/State tax')],
    vat: [__('Sales Tax'), __('VAT %(rate)s%%', { rate })],
  };
}

export default function TotalTaxRow({ tax, currency }: Props): Node {
  const translator = useTranslator();
  const { __, formatPrice } = translator;

  // $FlowFixMe[invalid-computed-prop]
  const { [tax.name]: taxLabels } = useTaxLabels(tax);

  return (
    <div className={styles.container}>
      <p>
        {taxLabels[0]}
        {taxLabels[1] && <span>{taxLabels[1]}</span>}
        {tax.name === 'zipcode' && (
          <PopoverIcon id="popover-total-tax-row-info" icon="infoWire">
            {__('This is the combined amount of your state and local tax')}
          </PopoverIcon>
        )}
      </p>
      {/* $FlowFixMe amount is missing in Tax type */}
      <p>{formatPrice(tax.amount, currency)}</p>
    </div>
  );
}
